import { InitialIntegrationReducer } from "../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../_commons/integration.reducer";

export const initialAmazonPayReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const amazonPaySlice = createSlice({
    name: "AmazonPay",
    initialState: { ...initialAmazonPayReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default amazonPaySlice;
